<section class="thankyou" id="thankyou" *ngFor="let post of posts" >
    <div class="container">
        <div [innerHTML]="post.content.rendered">
        
        </div>
    </div>
    
</section>    
